import { render } from "./CreateLocationForm.vue?vue&type=template&id=fef84264&scoped=true"
import script from "./CreateLocationForm.vue?vue&type=script&lang=js"
export * from "./CreateLocationForm.vue?vue&type=script&lang=js"

import "./CreateLocationForm.vue?vue&type=style&index=0&id=fef84264&lang=postcss&scoped=true"

import exportComponent from "/codebuild/output/src804629530/src/be-admin-portal/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fef84264"]])

export default __exports__